/**
 * Timeline utilities for converting Firestore events to Timeline entries
 */

import type { FirestoreAgentProgressEvent } from '~/context/RealTimeUpdatesChatContext';
import type { TimelineEntry } from '~/core/molecules/Timeline/types';

/**
 * Convert Firestore Agent Progress Events to Timeline entries
 */
export const convertEventsToTimelineEntries = (events: FirestoreAgentProgressEvent[]): TimelineEntry[] => {
  // Sort events by timestamp (ascending - oldest first)
  const sortedEvents = [...events].sort((a, b) => {
    return new Date(a.timestamp).getTime() - new Date(b.timestamp).getTime();
  });

  return sortedEvents.map((event) => ({
    id: event.event_id,
    title: event.title || event.event_type || 'Progress Update',
    content: event.message,
  }));
};
